import icon from "../../assets/smartphone.svg";
import type { Property } from "../../types";

export const mobileAppAccess: Property = {
  id: "mobileAppAccess",
  title: "mobileAppAccess.title",
  icon,
};
